import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskTag = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-tag',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-tag' }
    ),
    { }
  )
)()

export { taskTag, TYPES }
